import { createNamespacedHelpers } from "vuex";
const gameVuex = createNamespacedHelpers("game");
export default {
  computed: {
    ...gameVuex.mapState(["gameApp"]),
  },
};
